var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5759 21.888L20.1519 19.456C21.7199 18 22.0239 17.008 22.0239 15.92C22.0239 13.888 20.3599 12.608 17.8639 12.608C15.8479 12.608 14.2799 13.424 13.4159 14.688L15.3039 15.904C15.8479 15.152 16.6639 14.784 17.6239 14.784C18.8079 14.784 19.4159 15.296 19.4159 16.176C19.4159 16.72 19.2399 17.296 18.2479 18.24L13.9279 22.32V24H22.3919V21.888H17.5759Z",
    fill: "#5F61BE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 15.5,
    stroke: "#7476D1",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo2);
export default __webpack_public_path__ + "static/media/two2.a380fdd005fb31760e705695a750a219.svg";
export { ForwardRef as ReactComponent };